import { Resource } from '@setvi/shared/interfaces';
import { SETVIImage, SText } from '@setvi/shared/components';
import { GetResourceTypeThumbnail } from 'Utils/getResourceTypeThumbnail';
import { Box } from '@material-ui/core';
import { GetResourceTypeIcon } from 'Utils/getResourceTypeIcon';
import { GetResourceTypeName } from 'Utils/getResourceTypeName';
import { TextColor } from '@setvi/shared/enums';
import { Container, ImageWrapper } from './styled';

interface MobileResourceCardProps {
  resource: Pick<
    Resource,
    | 'Name'
    | 'ResourceTypeID'
    | 'ResourceTypeName'
    | 'ThumbURL'
    | 'ThumbURLWithSas'
  >;
}

export const MobileResourceCard = ({ resource }: MobileResourceCardProps) => (
  <Container>
    <ImageWrapper>
      <SETVIImage
        alt="image"
        style={{ width: '100%' }}
        src={
          resource?.ThumbURLWithSas ||
          resource?.ThumbURL ||
          GetResourceTypeThumbnail(resource?.ResourceTypeID)
        }
      />
    </ImageWrapper>
    <Box display="flex" flexDirection="column" gridGap={4}>
      <SText weight="semibold" size="sm" maxLines={2} title={resource?.Name} />
      <Box>
        <Box display="flex" gridGap={2}>
          <img width={20} src={GetResourceTypeIcon(resource?.ResourceTypeID)} />
          <SText
            title={
              GetResourceTypeName(resource?.ResourceTypeID) ||
              resource?.ResourceTypeName
            }
            size="sm"
            fontColor={TextColor.LightGrey}
          />
        </Box>
      </Box>
    </Box>
  </Container>
);
